import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogTitle,
  Command,
} from '@exiftrator/shared/components/ui';
import { X } from 'lucide-react';

function SplitCommandModalShell({
  open,
  onOpenChange,
  title,
  description,
  search,
  results,
  preview,
  footer,
  mobilePreviewLabel = 'Preview',
  mobileResultsLabel = 'Results',
  commandProps = {},
}) {
  const [mobileTab, setMobileTab] = useState('results');

  useEffect(() => {
    if (open) {
      setMobileTab('results');
    }
  }, [open]);

  const { className: commandClassName, ...restCommandProps } = commandProps;

  const tabBaseClasses =
    'flex-1 rounded-sm px-3 py-1.5 text-xs font-bold uppercase tracking-wider transition-colors';

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        placement="top"
        className="w-[calc(100%-1rem)] max-w-[760px] overflow-hidden p-0 sm:w-[calc(100%-2rem)] sm:max-w-[760px]"
        showCloseButton={false}
        onEscapeKeyDown={() => onOpenChange(false)}
      >
        <DialogTitle className="sr-only">{title}</DialogTitle>
        <DialogDescription className="sr-only">{description}</DialogDescription>
        <DialogClose className="ring-offset-background focus:ring-ring data-[state=open]:bg-accent data-[state=open]:text-muted-foreground absolute top-3 right-3 z-20 rounded-xs bg-background/90 p-1.5 opacity-90 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-hidden md:hidden">
          <X className="size-4" />
          <span className="sr-only">Close</span>
        </DialogClose>

        <div className="flex max-h-[min(84vh,860px)] min-h-[420px] flex-col bg-background md:max-h-[min(70vh,720px)] md:min-h-[520px]">
          <Command
            className={`flex min-h-0 flex-1 flex-col rounded-none bg-transparent ${commandClassName || ''}`}
            disablePointerSelection
            {...restCommandProps}
          >
            <div className="shrink-0 border-b border-border-subtle">{search}</div>

            <div className="border-b border-border-subtle px-2 py-2 md:hidden">
              <div className="grid grid-cols-2 gap-1 rounded-md bg-muted/60 p-1">
                <button
                  type="button"
                  className={`${tabBaseClasses} ${mobileTab === 'results' ? 'bg-background text-foreground shadow-sm' : 'text-muted-foreground hover:text-foreground'}`}
                  onClick={() => setMobileTab('results')}
                >
                  {mobileResultsLabel}
                </button>
                <button
                  type="button"
                  className={`${tabBaseClasses} ${mobileTab === 'preview' ? 'bg-background text-foreground shadow-sm' : 'text-muted-foreground hover:text-foreground'}`}
                  onClick={() => setMobileTab('preview')}
                >
                  {mobilePreviewLabel}
                </button>
              </div>
            </div>

            <div className="grid min-h-0 flex-1 md:grid-cols-[minmax(0,2fr)_minmax(280px,3fr)]">
              <div
                className={`${mobileTab === 'results' ? 'flex' : 'hidden'} min-h-0 flex-col border-r border-border-subtle md:flex`}
              >
                <div className="min-h-0 flex-1">{results}</div>
              </div>

              <div
                className={`${mobileTab === 'preview' ? 'flex' : 'hidden'} min-h-0 flex-col bg-bg-secondary md:flex`}
              >
                {preview}
              </div>
            </div>
          </Command>

          {footer && (
            <div className="shrink-0 border-t border-border-subtle bg-background px-3 py-2 md:px-4 md:py-3">
              {footer}
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default SplitCommandModalShell;
